export default function PHP_mail() {
  return (
    <div>
      <h1>PHP_mail</h1>
    </div>
  );
}
